export { default } from "./MailingListQuery";



// WEBPACK FOOTER //
// ./src/queries/MailingListQuery/index.ts